import { useCallback } from "react";
import { Widget } from "@rjsf/core";
import { FormMessage, PhoneNumber } from "@xometry/xometry_loft";

import { LabelWithOptionalFlag } from "./LabelWithOptionalFlag";
import { Section, ShortText } from "./Shared.style";

export const LoftPhoneNumber: Widget = ({
  disabled,
  required,
  schema,
  rawErrors,
  options,
  value,
  onChange,
  onBlur,
  uiSchema,
}) => {
  const handleBlur = useCallback(() => {
    onBlur(options?.name as string, value);
  }, [options?.name, value]);

  const handleChange = useCallback(newValue => {
    onChange(newValue);
  }, []);

  const isInvalid = !!(rawErrors?.length > 0 && options?.touched);

  return (
    <div css={[Section, ShortText]}>
      <LabelWithOptionalFlag
        required={required}
        tooltip={(options?.tooltip || "") as string}
      >
        {schema?.title}
      </LabelWithOptionalFlag>
      <div>
        <PhoneNumber
          disabled={disabled}
          inputProps={{ disabled }}
          onBlur={handleBlur}
          onChange={handleChange}
          specialLabel=""
          invalid={isInvalid}
          value={typeof value === "string" ? value : ""}
        />
      </div>
      {uiSchema?.description && (
        <FormMessage>{uiSchema.description}</FormMessage>
      )}
      {isInvalid && (
        <FormMessage invalid>{rawErrors ? rawErrors[0] : ""}</FormMessage>
      )}
    </div>
  );
};
